import type { FaireProductEntity } from "../../entity_types/product";

export const p_f4vvkgezfn: FaireProductEntity = {
  token: "p_f4vvkgezfn",
  type: "product",
  name: "Chocolate Chip Creme Sandwich - 3 PK Box",
  brandToken: "b_1q83xmlpct",
  brandName: "Maxine's Heavenly",
  imageUrl:
    "https://cdn.faire.com/fastly/e7dfd9de5cfe03f87a038ebefc93a6481866375d483521c1a085ca8c63b137e7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e0e18c30f03ccf7931cee0d79a09a658a1f961459d87cca5ad375876ce3cffef.jpeg",
    "https://cdn.faire.com/fastly/06bd6a94c357d6f969d32deec37eef1deda8ce428e4a56c00261267fdc6245c7.png",
  ],
  priceDollars: 4.14,
  description:
    "Homemade-style, classic chocolate chip cookies come together through a layer of fluffy, sweet vanilla creme that tastes like your own private cookie cake.\n\nThis box holds 3 individually wrapped oatmeal creme sandwiches.",
  tags: [],
  msrpDollars: 6.91,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:43.783Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
